function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { DropdownMenu, DropdownMenuItem, IconButton, Spinner } from 'seagull';
import { CircledQuestion24, Flag } from 'seagull/icons';
import { openInNewTabProps } from "../../../constants";
import { useFeatureFlags } from "../../../hooks/useFeatureFlags";
import { Intent } from "../../../infra/access-control";
import styles from "./HelpMenu.module.scss";
import { ExternalLink, useHelpMenuExternalLinks } from "../../../hooks/useHelpMenuExternalLinks";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export function HelpMenu(_ref) {
  let {
    userId
  } = _ref;
  const {
    HELP_MENU_NEW_DESIGN
  } = useFeatureFlags();
  const [appcuesState, setAppcuesState] = useState(null);
  const location = useLocation();
  const {
    externalLinks
  } = useHelpMenuExternalLinks();
  useEffect(() => {
    if (HELP_MENU_NEW_DESIGN) return;
    setAppcuesState(null);
  }, [HELP_MENU_NEW_DESIGN, location]);
  async function appcuesRequest() {
    setAppcuesState({
      status: 'loading'
    });
    const url = new URL("https://api.appcues.com/v1/accounts/".concat(window.appcuesAccountId, "/users/").concat(userId, "/taco"));
    url.searchParams.set('url', window.location.href);
    try {
      const response = await fetch(url.toString());
      const {
        contents
      } = await response.json();
      if (contents) {
        const flows = contents.map(_ref2 => {
          let {
            name,
            id
          } = _ref2;
          return {
            name,
            id
          };
        });
        setAppcuesState({
          status: 'success',
          flows
        });
      } else {
        throw new Error('failed to load appcues because of missing data');
      }
    } catch (error) {
      setAppcuesState({
        status: 'error'
      });
    }
  }
  return /*#__PURE__*/_jsxs(DropdownMenu, {
    minWidth: 175,
    onOpenChange: open => {
      if (!HELP_MENU_NEW_DESIGN && open && window.Appcues && window.appcuesAccountId && appcuesState === null) {
        appcuesRequest();
      }
    },
    target: /*#__PURE__*/_jsx(IconButton, {
      noPadding: true,
      intent: Intent.OpenHelpMenu,
      size: "small",
      "data-testid": "home-sidebar-help-menu-btn",
      children: /*#__PURE__*/_jsx(CircledQuestion24, {})
    }),
    children: [!HELP_MENU_NEW_DESIGN && /*#__PURE__*/_jsxs(_Fragment, {
      children: [(appcuesState === null || appcuesState === void 0 ? void 0 : appcuesState.status) === 'loading' && /*#__PURE__*/_jsx(DropdownMenuItem, {
        "data-testid": "home-sidebar-menuitem-appcues-spinner",
        iconStart: /*#__PURE__*/_jsx(Spinner, {
          size: 24
        }),
        children: "Loading\u2026"
      }), (appcuesState === null || appcuesState === void 0 ? void 0 : appcuesState.status) === 'success' && appcuesState.flows.map(c => /*#__PURE__*/_jsx(DropdownMenuItem, {
        iconStart: /*#__PURE__*/_jsx(Flag, {}),
        "data-testid": "home-sidebar-menuitem-appcues-campaign-".concat(c.name),
        onClick: () => {
          window.Appcues.show(c.id);
        },
        children: c.name
      }, c.id)), ((appcuesState === null || appcuesState === void 0 ? void 0 : appcuesState.status) === 'success' && appcuesState.flows.length > 0 || (appcuesState === null || appcuesState === void 0 ? void 0 : appcuesState.status) === 'loading') && /*#__PURE__*/_jsx("div", {
        "data-testid": "home-sidebar-menuitem-appcues-separator",
        className: styles.separator
      })]
    }), externalLinks.map(link => /*#__PURE__*/_jsx(DropdownMenuItem, _objectSpread(_objectSpread({
      "data-testid": "home-sidebar-menuitem-".concat(link.label),
      iconStart: HELP_MENU_NEW_DESIGN && link.icon ? /*#__PURE__*/_jsx(link.icon, {}) : null
    }, link.type === ExternalLink.Link ? _objectSpread({
      as: 'a',
      href: link.href
    }, openInNewTabProps) : {
      onClick: link.onClick
    }), {}, {
      children: link.label
    }), link.label))]
  });
}